import jwtDecode, { JwtPayload } from 'jwt-decode'
import { Token } from '../types'
import { calculateNextRefresh } from './calculateNextRefresh'

export function decodeToken<
  TokenPayload extends JwtPayload = JwtPayload
>(
  token: string
): Token<TokenPayload> | null {
  try {
    const payload = jwtDecode<TokenPayload>(token)
    if (!payload) return null
    return {
      token,
      payload,
      refetchAt: calculateNextRefresh(payload?.exp),
    }
  } catch { }
  return null
}
